// extracted by mini-css-extract-plugin
module.exports = {"library-books":"LibraryBooks_library-books__jDAKS"};